var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArrowFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z",
    fill: "#FFB6BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2929 14.7071C10.6834 15.0976 11.3166 15.0976 11.7071 14.7071C12.0976 14.3166 12.0976 13.6834 11.7071 13.2929L10.2929 14.7071ZM7.70711 10.7071L8.41421 10L8.41421 10L7.70711 10.7071ZM7.70711 9.29289L7 8.58579L7 8.58579L7.70711 9.29289ZM11.7071 6.70711C12.0976 6.31658 12.0976 5.68342 11.7071 5.29289C11.3166 4.90237 10.6834 4.90237 10.2929 5.29289L11.7071 6.70711ZM11.7071 13.2929L8.41421 10L7 11.4142L10.2929 14.7071L11.7071 13.2929ZM8.41421 10L11.7071 6.70711L10.2929 5.29289L7 8.58579L8.41421 10ZM8.41421 10L8.41421 10L7 8.58579C6.21895 9.36683 6.21895 10.6332 7 11.4142L8.41421 10Z",
    fill: "#3D0E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowFilled);
export default __webpack_public_path__ + "static/media/ic_arrow_filled.ef4e7e48732ab25de97c555382f4b850.svg";
export { ForwardRef as ReactComponent };